<template>
  <div v-if="container" class="rules-tab">
    <div class="rules-tab__scroll">
      <div class="rules-tab__choice-line">
        <span class="rules-tab__choice-line-label">Владелец</span>
        <app-select
          v-model="selectedPerson"
          class="rules-tab__choice-line-select"
          dropdown-class="select-dropdown--choice-rules-modal"
          :custom-search-style="{width: '430px'}"
          placeholder="Выбрать пользователей"
          :items="optionsPersons"
          :min-dropdown-width="665"
          :dropdown-height="600"
          searchable
          owner-choise
          @open="openDropdown"
          @close="closeDropdown"
        >
          <template
            #dropdown="{ items, selected, select, getGroupState, search }"
          >
            <UserGroupDropdownContent
              :items="items"
              :selected="selected"
              :select="select"
              :get-group-state="getGroupState"
              :updateSelected="updateSelected"
              :search="search"
              :single-mode="true"
              :current-owner="selectedPerson"
            />
          </template>
        </app-select>
      </div>
      <div class="rules-tab__choice-line">
        <span class="rules-tab__choice-line-label">Специальные права</span>
        <app-select
          v-model="selectedPersonSpecial"
          dropdown-class="select-dropdown--choice-rules-modal"
          class="rules-tab__choice-line-select"
          :custom-search-style="{width: '430px'}"
          style="width: 170px;"
          placeholder="Добавить"
          :items="optionsPersonsSpecial"
          :min-dropdown-width="697"
          :dropdown-height="559"
          dropdown-label="Добавить"
          searchable
          multiple
          @open="openDropdown"
          @close="closeDropdown"
          :closeOnSelect="false"
        >
          <template
            #dropdown="{ items, selected, select, getGroupState, search }"
          >
            <UserGroupDropdownContent
              :items="items"
              :selected="selected"
              :select="select"
              :get-group-state="getGroupState"
              :updateSelected="updateSelectedSpecial"
              :search="search"
            />
          </template>
        </app-select>
      </div>
      <div style="display: flex; flex-direction: column; gap: 8px">
      <!-- <div> -->
        <template v-if="sections[2].rules?.length">
          <div
            v-for="(rule, i) in sections[2].rules"
            :key="`${sections[2].key}-${rule.Group.Id}-${i}`"
            class="rules-tab__rule"
            :class="[{'rules-tab__rule-visible' : rule.Visible}]"
          >
            <div
              class="rules-tab__rule-header"
              @click="rule.Visible = !rule.Visible"
            >
              <span class="rules-tab__rule-group">
                {{ rule.Group.Name }}
              </span>
              <app-tooltip
                :text="rule.Visible ? 'Развернуть список' : 'Свернуть список'"
                ><template #activator>
                  <app-icon
                    :name="'chevron-down'"
                    :class="{ 'rules-tab__rule-chevron--open': rule.Visible }"
                    width="14px"
                    color="#979797"
                    hover-color="#377444"
                    class="rules-tab__rule-chevron"
                    @mousedown.prevent
                  />
                </template>
              </app-tooltip>
              <app-tooltip text="Удалить специальные права"
                ><template #activator>
                  <app-icon
                    :name="'close-bold'"
                    :class="{ 'rules-tab__rule-chevron': rule.Visible == true }"
                    width="12px"
                    color="#D2D2D2"
                    hover-color="#D05A4F"
                    class="rules-tab__rule-icon"
                    @mousedown.prevent
                    @click.stop="onDeleteSpecialRule(rule)"
                  />
                </template>
              </app-tooltip>
            </div>
            <div v-if="rule.Visible" class="rules-tab__rule-body">
              <!-- <div v-if="!sections[0].readonly" class="rules-tab__rule-bulk"> -->
              <div class="rules-tab__rule-body-bulk">
                <!-- <button
                class="rules-tab__bulk-btn rules-tab__bulk-btn--allow"
                @click.stop="setAllRules(rule, 'max')"
              > -->
                <button
                  class="rules-tab__rule-body-bulk-btn rules-tab__bulk-btn--allow"
                  @click.stop="setAllRules(rule, 'max')"
                >
                  Разрешить всё
                </button>
                <!-- <button
                class="rules-tab__bulk-btn rules-tab__bulk-btn--deny"
                @click.stop="setAllRules(rule, 'min')"
              > -->
                <button
                  class="rules-tab__rule-body-bulk-btn rules-tab__bulk-btn--deny"
                  @click.stop="setAllRules(rule, 'min')"
                >
                  Запретить всё
                </button>
              </div>
              <div
                v-for="selector in rule.Rules"
                :key="selector.Id"
                class="rules-tab__selector"
              >
                <label class="rules-tab__selector-label">{{
                  selector.Text
                }}</label>
                <app-select
                  class="rules-tab__selector-select"
                  dropdown-class="select-dropdown--update-rules-modal"
                  :class="selectClass(selector)"
                  :model-value="String(selector.Value)"
                  :items="optionsFor(selector.RuleType)"
                  :custom-trigger-style="stylesTrigger"
                  @update:model-value="(val: any) => onSelectChange(rule, selector, String(val))"
                />
                <!-- <app-select
								class="rules-tab__selector-select"
								:class="selectClass(selector)"
								:model-value="String(selector.Value)"
								:items="optionsFor(selector.RuleType)"
								:disabled="section.readonly"
								@update:model-value="(val: any) => onSelectChange(rule, selector, String(val))"
							/> -->
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div class="rules-tab__line" />
  <div class="rules-tab__actions">
    <app-button type="secondary" label="Отмена" @click="onCancel" />
    <app-button
      type="primary"
      label="Сохранить"
      @click="save"
      :disabled="!hasChanges || selectedPerson === null"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import AppSelect, {
  SelectOption,
} from "@/components/ui-kit/select/AppSelect.vue";
import UserGroupDropdownContent from "@/components/permitions/UserGroupDropdownContent.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { AccessApi } from "@/ api/AccessApi";
import {
  CommonEntity,
  CommonRule,
  EntityRulesContainer,
  RuleElement,
  WorkersAndAccessGroupsInSettingsGiver,
} from "@/models/interfaces/access/entity-rules";
import moment from "moment";
import { WorkerApi } from "@/ api/WorkerApi";
import { WorkerListItem } from "@/store/jobs";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

interface SectionDef {
  key: string;
  title: string;
  rules: CommonRule[];
  visible: boolean;
  readonly: boolean;
  toggle: () => void;
}

const props = defineProps<{
  container: EntityRulesContainer | null;
  entityId: number;
  canEdit: boolean;
  type: "client" | "project";
}>();

const emit = defineEmits<{
  (e: "refresh"): void;
  (e: "save"): void;
  (e: "cancel"): void;
  (e: "openDropdown"): void;
  (e: "closeDropdown"): void;
}>();

const localContainer = ref<EntityRulesContainer | null>(null);
const addGroupSection = ref<string | null>(null);
const availableGroups = ref<CommonEntity[]>([]);
const availableRulesTemplate = ref<RuleElement[]>([]);
const isLoadingGroups = ref(false);

const pendingDeletes = ref<{ ruleId: number; groupId: number }[]>([]);
const initialState = ref<{
  owner: number | null;
  special: (string | number)[];
  rulesValues: Record<number, Record<string, number>>;
} | null>(null);

const hasChanges = computed(() => {
  if (!initialState.value) return false;

  if (selectedPerson.value !== initialState.value.owner) {
    return true;
  }

  if (pendingDeletes.value.length > 0) {
    console.log("[hasChanges] pendingDeletes:", pendingDeletes.value);
    return true;
  }

  const currentSpecial = selectedPersonSpecial.value as (string | number)[];
  const initialSpecial = initialState.value.special;
  if (currentSpecial.length !== initialSpecial.length) {
    return true;
  }
  const currentSet = new Set(currentSpecial);
  if (initialSpecial.some((id) => !currentSet.has(id))) {
    return true;
  }

  if (
    localContainer.value &&
    Array.isArray(localContainer.value.SpecialRules)
  ) {
    for (const rule of localContainer.value.SpecialRules) {
      if (rule.CanBeDeletedFront) continue;
      const initRule = initialState.value.rulesValues[rule.Group.Id as number];
      if (!initRule) continue;
      for (const re of rule.Rules) {
        if (initRule[re.Name] !== Number(re.Value)) return true;
      }
    }
  }

  return false;
});
const selectedPerson = ref<number | null>(null);
const selectedPersonSpecial = ref([]);

const stylesTrigger: any = {
  minHeight: `18px`,
  padding: 0,
  width: "fit-content",
  border: `none`,
  backgroundColor: `transparent`,
};
let isInitializing = false;

watch(
  () => props.container,
  (val) => {
    if (val) {
      isInitializing = true;
      localContainer.value = reactive({
        GlobalVisible: val.GlobalVisible,
        InheritVisible: val.InheritVisible,
        SpecialVisible: val.SpecialVisible,
        GlobalRules: val.GlobalRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
        InheritedRules: val.InheritedRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
        SpecialRules: val.SpecialRules.map((r) => ({
          ...r,
          Rules: r.Rules.map((re) => ({ ...re, Value: Number(re.Value) })),
        })),
      });

      const allRules = [
        ...val.GlobalRules,
        ...val.InheritedRules,
        ...val.SpecialRules,
      ];
      const ownerRule = allRules.find((r) => r.Owner);
      selectedPerson.value = ownerRule ? ownerRule.Group.Id : null;

      selectedPersonSpecial.value = val.SpecialRules.filter(
        (r) => !r.Owner,
      ).map((r) => r.Group.Id);

      const rulesValues: Record<number, Record<number, number>> = {};
      val.SpecialRules.filter((r) => !r.Owner).forEach((r) => {
        rulesValues[r.Group.Id] = {};
        r.Rules.forEach((re) => {
          rulesValues[r.Group.Id][re.Name] = Number(re.Value);
        });
      });

      initialState.value = {
        owner: ownerRule ? ownerRule.Group.Id : null,
        special: val.SpecialRules.filter((r) => !r.Owner).map(
          (r) => r.Group.Id,
        ),
        rulesValues,
      };

      nextTick(() => {
        isInitializing = false;
      });
    } else {
      localContainer.value = null;
      selectedPerson.value = null;
      selectedPersonSpecial.value = [];
      initialState.value = null;
      isInitializing = false;
    }

    addGroupSection.value = null;
  },
  { immediate: true },
);

const setAllRules = (rule: CommonRule, mode: "max" | "min") => {
  rule.Rules.forEach((selector) => {
    if (mode === "max") {
      if (selector.RuleType === 0) selector.Value = 2;
      else if (selector.RuleType === 1) selector.Value = 1;
      else selector.Value = 2;
    } else {
      if (selector.RuleType === 0) selector.Value = 0;
      else if (selector.RuleType === 1) selector.Value = 0;
      else selector.Value = 1;
    }
  });
  rule.CanSave = true;
};

const optionsDenyReadUpdate = [
  { id: "2", label: "Полный доступ" },
  { id: "1", label: "Чтение" },
  { id: "0", label: "Запрещено" },
];
const optionsAllowedDenied = [
  { id: "1", label: "Полный доступ" },
  { id: "0", label: "Запрещено" },
];
const optionsReadUpdate = [
  { id: "2", label: "Полный доступ" },
  { id: "1", label: "Чтение" },
];

const optionsFor = (ruleType: number) => {
  if (ruleType === 0) return optionsDenyReadUpdate;
  if (ruleType === 1) return optionsAllowedDenied;
  return optionsReadUpdate;
};

const selectClass = (s: RuleElement) => {
  if (s.RuleType === 0) {
    return {
      "rules-tab__selector-select--red": s.Value === 0,
      "rules-tab__selector-select--yellow": s.Value === 1,
      "rules-tab__selector-select--green": s.Value === 2,
    };
  }
  if (s.RuleType === 1) {
    return {
      "rules-tab__selector-select--red": s.Value === 0,
      "rules-tab__selector-select--green": s.Value === 1,
    };
  }
  return {
    "rules-tab__selector-select--yellow": s.Value === 1,
    "rules-tab__selector-select--green": s.Value === 2,
  };
};

const ruleTypeMap: Record<string, number> = {
  global: 0,
  inherited: 1,
  special: 2,
};

const onSelectChange = (
  rule: CommonRule,
  selector: RuleElement,
  val: string,
) => {
  selector.Value = Number(val);
  rule.CanSave = true;
};

const onCancel = () => {
  if (!initialState.value || !props.container) return;

  pendingDeletes.value = [];

  selectedPerson.value = initialState.value.owner;

  isInitializing = true;
  selectedPersonSpecial.value = [...initialState.value.special];
  nextTick(() => {
    isInitializing = false;
  });

  if (localContainer.value) {
    localContainer.value.SpecialRules = props.container.SpecialRules.map(
      (r) => ({
        ...r,
        Rules: r.Rules.map((re) => ({ ...re })),
      }),
    );
  }

  emit("cancel");
};

const canDeleteRule = (rule: CommonRule, sectionKey: string) => {
  if (sectionKey === "inherited") {
    return !rule.Owner && (rule.CanDelete || rule.CanBeDeletedFront);
  }
  if (sectionKey === "special") {
    return rule.CanDelete || rule.CanBeDeletedFront;
  }
  return false;
};

const onSaveRule = async (rule: CommonRule, sectionKey: string) => {
  try {
    if (props.type == "client")
      await AccessApi.saveRuleInClient(
        props.entityId,
        rule.Rules,
        rule.Group.Id,
        ruleTypeMap[sectionKey],
      );
    else
      await AccessApi.saveRuleInProject(
        props.entityId,
        rule.Rules,
        rule.Group.Id,
        ruleTypeMap[sectionKey],
      );
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const onDeleteRule = async (rule: CommonRule, section: SectionDef) => {
  if (rule.CanBeDeletedFront) {
    const idx = section.rules.findIndex((r) => r.Group.Id === rule.Group.Id);
    if (idx !== -1) section.rules.splice(idx, 1);
    return;
  }

  try {
    console.log(props.type);
    const inherited = section.key === "inherited";
    if (props.type == "client")
      await AccessApi.removeRuleInClient(
        rule.Id,
        props.entityId,
        inherited,
        rule.Group.Id,
      );
    else
      await AccessApi.removeRuleInProject(
        rule.Id,
        props.entityId,
        inherited,
        rule.Group.Id,
      );
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const onDeleteSpecialRule = (rule: CommonRule) => {
  if (rule.CanBeDeletedFront) {
    selectedPersonSpecial.value = selectedPersonSpecial.value.filter(
      (id) => id !== rule.Group.Id,
    );
  } else {
    pendingDeletes.value.push({ ruleId: rule.Id, groupId: rule.Group.Id });
    const specialRules = sections.value[2].rules;
    const idx = specialRules.findIndex((r) => r.Group.Id === rule.Group.Id);
    if (idx !== -1) specialRules.splice(idx, 1);
    selectedPersonSpecial.value = selectedPersonSpecial.value.filter(
      (id) => id !== rule.Group.Id,
    );
  }
};

const onAddGroup = async (section: SectionDef) => {
  if (addGroupSection.value === section.key) {
    addGroupSection.value = null;
    return;
  }

  try {
    isLoadingGroups.value = true;
    const result =
      props.type == "client"
        ? await AccessApi.getGroupsInClient(props.entityId)
        : await AccessApi.getGroupsInProject(props.entityId);
    const existingIds = new Set(section.rules.map((r) => r.Group.Id));
    availableGroups.value = (result.Groups ?? []).filter(
      (g) => !existingIds.has(g.Id),
    );
    availableRulesTemplate.value = result.Rules ?? [];
    addGroupSection.value = section.key;
  } catch (e) {
    console.error(e);
  } finally {
    isLoadingGroups.value = false;
  }
};

const onPickGroup = (group: CommonEntity, section: SectionDef) => {
  const newRule: CommonRule = reactive({
    Id: 0,
    Visible: false,
    CanSave: true,
    CanDelete: false,
    CanBeDeletedFront: true,
    Group: { Id: group.Id, Name: group.Name },
    Rules: availableRulesTemplate.value.map((r) => ({ ...r })),
    Global: false,
    Owner: false,
    Inherited: section.key === "inherited",
    OwnerGroup: null,
    Reduced: false,
    Advanced: false,
    Given: false,
  });
  section.rules.push(newRule);
  addGroupSection.value = null;
};

const sections = computed<SectionDef[]>(() => {
  const c = localContainer.value;
  if (!c) return [];

  return [
    {
      key: "global",
      title: "Глобальные права",
      rules: c.GlobalRules,
      visible: c.GlobalVisible,
      readonly: true,
      toggle: () => (c.GlobalVisible = !c.GlobalVisible),
    },
    {
      key: "inherited",
      title: "Наследуемые права",
      rules: c.InheritedRules,
      visible: c.InheritVisible,
      readonly: !props.canEdit,
      toggle: () => (c.InheritVisible = !c.InheritVisible),
    },
    {
      key: "special",
      title: "Особые права",
      rules: c.SpecialRules,
      visible: c.SpecialVisible,
      readonly: !props.canEdit,
      toggle: () => (c.SpecialVisible = !c.SpecialVisible),
    },
  ];
});

// const workers = ref<WorkerListItem[]>([]);
const groupsRules = ref<WorkersAndAccessGroupsInSettingsGiver>();

onMounted(async () => {
  groupsRules.value = await AccessApi.getWorkersAndAccessGroups();

  try {
    const result =
      props.type === "client"
        ? await AccessApi.getGroupsInClient(props.entityId)
        : await AccessApi.getGroupsInProject(props.entityId);
    availableRulesTemplate.value = result.Rules ?? [];
  } catch (e) {
    console.error(e);
  }
});

watch(
  selectedPersonSpecial,
  (newVal: (string | number)[], oldVal: (string | number)[]) => {
    if (isInitializing) return;
    if (!localContainer.value) return;
    // ;
    const specialRules = sections.value[2].rules;

    const added = newVal.filter((id) => !oldVal.includes(id));
    const removed = oldVal.filter((id) => !newVal.includes(id));

    added.forEach((id) => {
      if (specialRules.some((r) => r.Group.Id === id)) return;

      const label = findLabelById(id);

      const newRule: CommonRule = reactive({
        Id: 0,
        Visible: false,
        CanSave: true,
        CanDelete: false,
        CanBeDeletedFront: true,
        Group: { Id: id as number, Name: label },
        Rules: availableRulesTemplate.value.map((r) => ({ ...r })),
        Global: false,
        Owner: false,
        Inherited: false,
        OwnerGroup: null,
        Reduced: false,
        Advanced: false,
        Given: false,
      });
      specialRules.push(newRule);
    });

    removed.forEach((id) => {
      const idx = specialRules.findIndex(
        (r) => r.Group.Id === id && r.CanBeDeletedFront,
      );
      if (idx !== -1) specialRules.splice(idx, 1);
    });
  },
  { deep: true },
);

const findLabelById = (id: string | number): string => {
  for (const item of optionsPersonsSpecial.value) {
    if (item.id === id) return item.label;
    if ("children" in item && item.children) {
      const child = item.children.find((c) => c.id === id);
      if (child) return child.label;
    }
  }
  return String(id);
};
const save = async () => {
  if (!localContainer.value) return;
  const specialSection = sections.value[2];
  const toSave = specialSection.rules.filter((r) => r.CanSave);

  try {
    if (
      selectedPerson.value !== null &&
      selectedPerson.value !== initialState.value?.owner
    ) {
      await AccessApi.editGroupOwnage(
        selectedPerson.value,
        props.type === "client",
        [props.entityId],
      );
    }

    for (const { ruleId, groupId } of pendingDeletes.value) {
      await (props.type === "client"
        ? AccessApi.removeRuleInClient(ruleId, props.entityId, false, groupId)
        : AccessApi.removeRuleInProject(
            ruleId,
            props.entityId,
            false,
            groupId,
          ));
    }

    for (const rule of toSave) {
      await (props.type === "client"
        ? AccessApi.saveRuleInClient(
            props.entityId,
            rule.Rules,
            rule.Group.Id,
            2,
          )
        : AccessApi.saveRuleInProject(
            props.entityId,
            rule.Rules,
            rule.Group.Id,
            2,
          ));
    }

    pendingDeletes.value = [];
    emit("save");
    emit("refresh");
  } catch (e) {
    console.error(e);
  }
};

const openDropdown = () => {
  emit("openDropdown");
};

const closeDropdown = () => {
  emit("closeDropdown");
};

// watch(
//   () => props.file,
//   async (newVal, oldVal) => {
//     // console.log(props.file);
//     fileInfo.value = newVal;

//     // fileInfo.value.Changelog = fileInfo.value.FileChanges.concat(
//     //   fileInfo.value.GroupChanges.concat(fileInfo.value.TagChanges),
//     // ).sort((a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime());
//   },
//   { immediate: true },
// );

// onMounted(() => {});
const updateSelected = (newSelected: (string | number)[]) => {
  selectedPerson.value =
    newSelected.length > 0
      ? (newSelected[newSelected.length - 1] as number)
      : null;
};

const updateSelectedSpecial = (newSelected) => {
  selectedPersonSpecial.value = newSelected;
};

// const save = () => {
//   emit("save");
// };

const optionsPersons = computed<SelectOption[]>(() => {
  if (!groupsRules.value?.Holders.length) return [];

  const groups: SelectOption[] = [];
  const workersWithoutDepartment: {
    id: number;
    label: string;
    type: "item";
  }[] = [];

  groupsRules.value?.Holders.forEach((el, index) => {
    if (el.Departament) {
      groups.push({
        id: index + 999999,
        label: el.Departament.Name,
        type: "group" as const,
        selectable: true,
        children:
          el.Departament.Workers?.map((worker) => ({
            id: worker.GroupId,
            label: worker.Name,
            type: "item" as const,
          })) ?? [],
      });
    } else if (el.IsWorker && el.Worker) {
      workersWithoutDepartment.push({
        id: el.Worker.GroupId,
        label: el.Worker.Name,
        type: "item" as const,
      });
    }
  });

  groupsRules.value?.Groups.forEach((el, index) => {
    // if (el.Departament) {
    if (!el.IsPersonal) {
      groups.push({
        id: el.Id,
        label: el.Name,
        type: "group" as const,
        selectable: true,
        children: [],
      });
    }
  });

  if (workersWithoutDepartment.length > 0) {
    groups.push({
      id: -1,
      label: "Без отдела",
      type: "group" as const,
      selectable: false,
      children: workersWithoutDepartment,
    });
  }

  return groups;
});

const optionsPersonsSpecial = computed<SelectOption[]>(() => {
  if (!groupsRules.value?.Holders.length) return [];

  const groups: SelectOption[] = [];
  const workersWithoutDepartment: {
    id: number;
    label: string;
    type: "item";
  }[] = [];

  groupsRules.value?.Holders.forEach((el, index) => {
    if (el.Departament) {
      groups.push({
        id: index + 999999,
        label: el.Departament.Name,
        type: "group" as const,
        selectable: true,
        children:
          el.Departament.Workers?.map((worker) => ({
            id: worker.GroupId,
            label: worker.Name,
            type: "item" as const,
          })) ?? [],
      });
    } else if (el.IsWorker && el.Worker) {
      workersWithoutDepartment.push({
        id: el.Worker.GroupId,
        label: el.Worker.Name,
        type: "item" as const,
      });
    }
  });

  groupsRules.value?.Groups.forEach((el, index) => {
    if (!el.IsPersonal) {
      groups.push({
        id: el.Id,
        label: el.Name,
        type: "group" as const,
        selectable: true,
        children: [],
      });
    }
  });

  if (workersWithoutDepartment.length > 0) {
    groups.push({
      id: -1,
      label: "Без отдела",
      type: "group" as const,
      selectable: false,
      children: workersWithoutDepartment,
    });
  }

  return groups;
});

const showAllChanges = ref(false);

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

.rules-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  // padding: 12px 16px;
  gap: 16px;
  overflow: hidden;

  &__scroll {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    gap: 16px;
  }

  &__choice-line {
    display: flex;
    gap: 16px;
    align-items: center;

    &-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: $color-text_main;
    }

    &-select {
      width: 240px;
      align-self: start;
      // height: 24px;
    }
  }

  &__section-title {
    display: inline-flex;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    color: $color-text_main;

    &-text {
      border-bottom: 1px dashed #979797;

      &:hover {
        color: #396742;
      }
    }
  }

  &__rule {
    // margin-top: 6px;
    // margin-left: 12px;
    // gap: 8px;

    &-visible {
      margin-bottom: 8px;
    }

    &-header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      // margin-bottom: 8px;
      cursor: pointer;

      &:hover .rules-tab__rule-chevron {
        opacity: 1;
        transition: transform 0.2s ease, opacity 0.15s ease 0.3s;
      }

      &:hover .rules-tab__rule-icon,
      &:hover .rules-tab__rule-actions {
        opacity: 1;
        transition-delay: 0.3s;
      }

      .rules-tab__rule-chevron,
      .rules-tab__rule-icon,
      .rules-tab__rule-actions {
        transition-delay: 0s;
      }
    }

    &-actions {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-left: auto;
      opacity: 0;
      transition: opacity 0.15s ease 0.3s;
    }

    &-group {
      color: $color-text_main;
      font-size: 14px;

      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    // &-chevron {
    //   transform: scaleY(-1);
    // }
    &-chevron {
      flex-shrink: 0;
      color: #979797;
      opacity: 0;
      transition: transform 0.2s ease, opacity 0.15s ease 0.3s;

      &--open {
        transform: rotate(180deg);
      }
    }

    &-icon {
      flex-shrink: 0;
      opacity: 0;
      transition: opacity 0.15s ease 0.3s;
    }

    &-body {
      display: flex;
      flex-direction: column;
      //   gap: 6px;
      //   margin-left: 12px;
      // padding: 6px 0;

      &-bulk {
        display: flex;
        gap: 16px;

        &-btn {
          cursor: pointer;
          padding: 0;
          width: 101px;
          font-weight: 400;
          height: 32px;
          width: max-content;
          background: $background-white;
          border-radius: 8px;
          border: none;
          color: $color-text-secondary;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    padding: 1px 6px;
    border-radius: 4px;
    color: #fff;

    &--global {
      background: yellowgreen;
    }
    &--owner {
      background: #00bfff;
    }
    &--inherited {
      background: green;
    }
    &--warn {
      background: orange;
    }
  }

  &__selector {
    // display: flex;
    display: grid;
    grid-template-columns: 290px 140px;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    line-height: 18px;
    padding: 4px 0px;

    &:nth-child(odd of .rules-tab__selector) {
      background-color: #f9f9f9;
      border-radius: 4px;
    }

    &-label {
      color: $color-text_main;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
    }

    &-select {
      //   width: 160px;
      //   background-color: transparent;
      align-self: flex-start;
      width: fit-content;
      padding: 0;

      :deep(.app-select__trigger) {
        min-height: 26px;
        padding: 2px 8px;
        border-radius: 4px;
      }

      &--red :deep(.app-select__trigger) {
        background: transparent;

        .app-select__value,
        .app-select__placeholder,
        span {
          color: #d05a4f;
        }
      }
      &--yellow :deep(.app-select__trigger) {
        background: transparent;

        .app-select__value,
        .app-select__placeholder,
        span {
          color: #e6c15a;
        }
      }
      &--green :deep(.app-select__trigger) {
        background: transparent;

        .app-select__value,
        .app-select__placeholder,
        span {
          color: #396742;
        }
      }
    }
  }

  &__add-group {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    margin-left: 12px;
    font-size: 13px;
    color: #499259;
    cursor: pointer;

    &:hover {
      color: #396742;
    }
  }

  &__group-picker {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    margin-top: 4px;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fff;

    &-item {
      padding: 6px 10px;
      font-size: 13px;
      color: $color-text_main;
      cursor: pointer;

      &:hover {
        background: #f0f0f0;
      }
    }
  }

  &__empty {
    margin-left: 12px;
    font-size: 13px;
    color: #979797;
  }

  &__line {
    margin-top: auto;
    border-bottom: 1px solid $color-border;
    flex-shrink: 0;
  }

  &__actions {
    font-size: 14px;
    line-height: 18px;
    // color: #333;
    // flex-direction: column;
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    margin-left: auto;
    flex-shrink: 0;

    &-weight {
      font-weight: 500;
    }
  }
}
</style>

<style lang="scss">
.select-dropdown--above-modal {
  z-index: 10002 !important;
}

.select-dropdown--choice-rules-modal {
  z-index: 10002 !important;
  border-radius: 8px;
  margin-left: -12px;
}

.select-dropdown--update-rules-modal {
  z-index: 10002 !important;
  width: 134px !important;
  border-radius: 8px;
}
</style>
